import { dictionaryCamelCaseConverter } from 'src/utils/dictionaryCamelCaseConverter';

export const sanitizeProjectPhases = (data) => dictionaryCamelCaseConverter(data);
